module.exports = __webpack_public_path__ + "static/media/van-huysum.c8ea090d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/van-huysum.jpg
// module id = 256
// module chunks = 1